import classNames from 'classnames'
import * as PropTypes from 'prop-types'
import React from 'react'

import Icon from '../../Icon/Icon'
import s from './FieldTextControlLayout.module.scss'

export default function FieldTextControlLayout({ children, onClearClick, invalid, size }) {
  return (
    <div className={s['field-text-control-layout']}>
      {children}
      {invalid && (
        <div className={classNames(s.icons, size === 's' ? s.xxs : s.xs)}>
          <button className={s.button} onClick={onClearClick} type="button">
            <Icon size={size === 's' ? 'xxs' : 'xs'} type="cross" />
          </button>
        </div>
      )}
    </div>
  )
}

FieldTextControlLayout.propTypes = {
  children: PropTypes.node.isRequired,
  invalid: PropTypes.bool.isRequired,
  onClearClick: PropTypes.func.isRequired,
  size: PropTypes.string
}
